export const pageTransition = {
	enter: (container: Document | Element = document, onComplete?: () => void) => {
		const fader = container.querySelector('.hg-fader') as HTMLElement

		if (!fader) {
			onComplete ? onComplete() : null
			return
		}

		fader.style.visibility = 'visible'
		fader.classList.add('is-entering')
		fader.classList.remove('is-exiting')
		document.documentElement.classList.add('on-transition')

		// Ensure there's a spinner inside the fader (for SPA navigation when reusing DOM)
		if (!fader.querySelector('.hg-spinner')) {
			const spinner = document.createElement('div')
			spinner.className = 'hg-spinner'
			fader.appendChild(spinner)
		}

		gsap.fromTo(
			fader,
			{ clipPath: 'inset(0% 0% 0% 0%)' },
			{
				clipPath: 'inset(0% 0% 100% 0%)',
				duration: 0.6,
				delay: 0.15,
				ease: 'expo.out',
				onComplete: () => {
					fader.style.clipPath = ''
					fader.style.visibility = 'hidden'
					fader.classList.remove('is-entering')
					document.documentElement.classList.remove('on-transition')
					onComplete ? onComplete() : null
				},
			}
		)
	},

	exit: (container: Document | Element = document, onComplete?: () => void) => {
		const fader = container.querySelector('.hg-fader') as HTMLElement

		if (!fader) {
			onComplete ? onComplete() : null
			return
		}

		document.documentElement.classList.add('on-transition')
		
		fader.classList.add('is-exiting')
		fader.style.visibility = 'visible'
		fader.style.clipPath = 'inset(100% 0% 0% 0%)'

		gsap.fromTo(
			fader,
			{ clipPath: 'inset(100% 0% 0% 0%)' },
			{
				clipPath: 'inset(0% 0% 0% 0%)',
				duration: 0.75,
				ease: 'expo.inOut',
				onComplete: () => {
					// fader.classList.remove('is-exiting')
					document.documentElement.classList.remove('on-transition')
					onComplete ? onComplete() : null
				},
			}
		)
	},
}
